export namespace DocumentTypeConstants {
  export const TOS_AGREEMENT_W9 = 'TOS Agreement W9';
  export const DRIVERS_LICENSE = 'Drivers license';
  export const AUTOMOBILE_INSURANCE = 'Automobile insurance';
  export const VEHICLE_REGISTRATION = 'Vehicle registration';
  export const VEHICLE_INSPECTION_CERTIFICATE = 'Vehicle inspection certificate';
  export const CA_UZURV_VEHICLE_INSPECTION_FORM = 'CA UZURV Vehicle Inspection Form';
  export const IL_VEHICLE_INSPECTION_FORM = 'IL Vehicle Inspection Form';
  export const UZURV_VEHICLE_INSPECTION_FORM = 'UZURV vehicle inspection form';
  export const VEHICLE_EMISSIONS_INSPECTION = 'Vehicle emissions inspection';
  export const STERLING_DISCLOSURE = 'Sterling disclosure';
  export const PROFILE_PICTURE = 'Profile picture';
  export const SIGNATURE = 'Signature';
  export const VEHICLE_IMAGE = 'Vehicle image';
}
